@charset "UTF-8";

/* src/app/global/components/global-regionsfilter/global-regionsfilter.component.scss */
:host {
  -webkit-flex: 1;
  -moz-flex: 1;
  -ms-flex: 1;
  flex: 1;
  overflow: hidden;
}
:host .cw-flex-row {
  height: 100%;
}
:host .cw-global-header-icon,
.cw-global-loading-icon {
  text-align: center;
  width: 60px;
}
:host .cw-global-header-icon {
  background-color: rgba(0, 0, 0, 0.1);
  cursor: pointer;
}
.cw-global-regionsfilter-icon {
  color: #fff;
  font-size: 2rem;
  line-height: 3;
}
.mat-mdc-button {
  font-weight: 400;
  line-height: 60px;
  padding: 0 15px 0 30px;
  text-transform: uppercase;
  height: 100%;
}
.mat-mdc-button:not(:disabled) {
  color: var(--mat-tree-node-text-color);
}
.reset-button {
  font-weight: 500;
  line-height: 20px;
  margin: 0 8px 0 8px;
  padding: 4px 8px 4px 0;
  text-align: left;
  width: calc(100% - 16px);
}
.mat-tree {
  background: var(--color-primary-light);
  margin: 0 8px 0 8px;
}
.mat-tree-node {
  background: var(--color-primary-light);
  border-bottom: 1px solid var(--color-primary-lighter);
  cursor: pointer;
  height: 30px;
  line-height: 30px;
  min-height: 30px;
  min-width: 150px;
  padding: 0 20px 0 0;
  white-space: nowrap;
}
.mat-tree-node:hover {
  background: rgba(0, 0, 0, 0.2);
}
.cw-breadcrumb:after {
  border: solid transparent;
  border-color: rgba(236, 145, 59, 0);
  border-left-color: var(--color-accent);
  border-width: 30px 15px;
  content: " ";
  height: 0;
  margin-top: -30px;
  position: absolute;
  right: -30px;
  top: 50%;
  width: 0;
  z-index: 30;
  pointer-events: none;
}
.cw-breadcrumb:before {
  border: solid transparent;
  border-color: rgba(240, 167, 98, 0);
  border-left-color: var(--color-accent-light);
  border-width: 39px 20px;
  content: " ";
  height: 0;
  left: 0px;
  margin-top: -39px;
  padding-right: 10px;
  position: absolute;
  top: 50%;
  z-index: 20;
  width: 0;
}
.cw-breadcrumb:first-child:not(.cw-breadcrumb-start):before {
  display: none;
}
.cw-breadcrumb-start:before {
  border-color: var(--color-accent-light);
  border-width: 15px 5px 15px 0;
  content: " ";
  height: 60px;
  margin-top: 0;
  padding-right: 0;
  pointer-events: none;
  position: absolute;
  right: 100%;
  top: 0;
}
.cw-breadcrumb-end:after {
  border-color: var(--color-accent-light);
  border-width: 15px 5px 15px 0;
  content: " ";
  height: 60px;
  left: 100%;
  position: absolute;
  pointer-events: none;
}
/*# sourceMappingURL=global-regionsfilter.component.css.map */
